(() => {
  const guides = {
  "carbon-credits": [
    {
      "heading": "A credit is a unit with a documented history",
      "label": "Carbon credits explained"
    },
    {
      "heading": "Choose the route that matches the purchase",
      "label": "Purchasing routes"
    },
    {
      "heading": "Build a complete picture before buying",
      "label": "Before you buy"
    },
    {
      "heading": "Primary references",
      "label": "Primary references"
    }
  ],
  "what-is-a-carbon-credit": [
    {
      "heading": "One tonne, quantified under stated rules",
      "label": "What a credit represents"
    },
    {
      "heading": "The unit begins with work on the ground",
      "label": "From project to credit"
    },
    {
      "heading": "What the unit does and does not tell you",
      "label": "What a credit tells you"
    },
    {
      "heading": "Primary references",
      "label": "Primary references"
    }
  ],
  "how-to-buy-carbon-credits": [
    {
      "heading": "Define the job the credits need to do",
      "label": "Define your requirements"
    },
    {
      "heading": "What to ask for in a carbon credit quotation",
      "label": "Reviewing a quotation"
    },
    {
      "heading": "Request options from the CO2balance team",
      "label": "Requesting options"
    },
    {
      "heading": "Questions worth asking",
      "label": "Questions to ask"
    },
    {
      "heading": "Primary references",
      "label": "Primary references"
    }
  ],
  "high-integrity-carbon-credits": [
    {
      "heading": "Integrity is built through several layers",
      "label": "The layers of integrity"
    },
    {
      "heading": "Project quality is visible in the detail",
      "label": "Assessing project quality"
    },
    {
      "heading": "Standards, labels and international uses",
      "label": "Standards and market uses"
    },
    {
      "heading": "Primary references",
      "label": "Primary references"
    }
  ],
  "carbon-credit-standards-integrity": [
    {
      "heading": "Programme, methodology, project and registry",
      "label": "How the system fits together"
    },
    {
      "heading": "Different questions sit at different levels",
      "label": "Choosing the right framework"
    },
    {
      "heading": "Primary references",
      "label": "Primary references"
    }
  ],
  "ccp-carbon-credits": [
    {
      "heading": "A quality label, not a new standard",
      "label": "What the label means"
    },
    {
      "heading": "How the CCP label works",
      "label": "How CCP labelling works"
    },
    {
      "heading": "What the Core Carbon Principles assess",
      "label": "The Core Carbon Principles"
    },
    {
      "heading": "What to check beyond the label",
      "label": "Beyond the label"
    },
    {
      "heading": "CCP and CORSIA serve different purposes",
      "label": "CCP and CORSIA"
    },
    {
      "heading": "CCP-labelled carbon credit questions",
      "label": "Common questions"
    }
  ],
  "corsia-carbon-credits": [
    {
      "heading": "CORSIA credit is common shorthand",
      "label": "What CORSIA means"
    },
    {
      "heading": "How operators meet a CORSIA obligation",
      "label": "Meeting an obligation"
    },
    {
      "heading": "Eligibility depends on the complete unit record",
      "label": "Checking eligibility"
    },
    {
      "heading": "ICAO determines which programmes and units qualify",
      "label": "Eligible programmes"
    },
    {
      "heading": "How authorisation supports credible use",
      "label": "Authorisation"
    },
    {
      "heading": "Questions to ask before purchasing",
      "label": "Before purchasing"
    },
    {
      "heading": "CORSIA carbon credit questions",
      "label": "Common questions"
    }
  ],
  "letter-of-authorisation": [
    {
      "heading": "A government authorisation with a defined scope",
      "label": "What an LoA covers"
    },
    {
      "heading": "How authorisation fits into an international transfer",
      "label": "International transfers"
    },
    {
      "heading": "What an LoA should make clear",
      "label": "What the document needs"
    },
    {
      "heading": "The purpose changes with the market framework",
      "label": "Different market uses"
    },
    {
      "heading": "Authorisation and corresponding adjustments are connected, but distinct",
      "label": "Corresponding adjustments"
    },
    {
      "heading": "Questions to ask before relying on an LoA",
      "label": "Due diligence"
    },
    {
      "heading": "Letter of Authorisation questions",
      "label": "Common questions"
    }
  ],
  "safe-water-carbon-credits": [
    {
      "heading": "Reliable water points can reduce household fuel use",
      "label": "How safe water reduces emissions"
    },
    {
      "heading": "Reliable water access, maintained locally",
      "label": "Local delivery"
    },
    {
      "heading": "How a safe water project is delivered",
      "label": "The project process"
    },
    {
      "heading": "The water point has to keep working",
      "label": "Monitoring and evidence"
    },
    {
      "heading": "Questions we are often asked",
      "label": "Common questions"
    }
  ],
  "cookstove-carbon-credits": [
    {
      "heading": "Lower fuel use, measured in everyday kitchens",
      "label": "How cookstoves reduce emissions"
    },
    {
      "heading": "Designed for the way people cook",
      "label": "Household use"
    },
    {
      "heading": "What sits behind a cookstove credit",
      "label": "The project process"
    },
    {
      "heading": "Distribution alone is not enough",
      "label": "Monitoring and evidence"
    },
    {
      "heading": "Questions we are often asked",
      "label": "Common questions"
    }
  ],
  "carbon-project-development-services": [
    {
      "heading": "Support for NGOs, communities, developers, landowners and funders",
      "label": "Who we support"
    },
    {
      "heading": "From project idea to delivery plan",
      "label": "The development process"
    },
    {
      "heading": "Feasibility before development",
      "label": "Feasibility and evidence"
    },
    {
      "heading": "Questions we are often asked",
      "label": "Common questions"
    }
  ]
};
  const loader = document.querySelector('[data-co2-guide]');
  const plan = loader && guides[loader.dataset.co2Guide];
  if (!plan) return;
  function mount() {
    const root = document.querySelector('.crc, .cgp, .codex-resource-page');
    if (!root || root.querySelector('.co2-guide-layout')) return;
    const blocks = [...root.children].filter(el => el.matches('section:not(.crc-cta):not(.cgp-cta):not(.crp-cta), .crc-sources'));
    if (!blocks.length) return;
    const headings = blocks.flatMap(el => [...el.querySelectorAll('h2')]);
    const links = plan.map(item => ({...item, target:headings.find(h => h.textContent.replace(/\s+/g,' ').trim() === item.heading)}));
    if (links.some(item => !item.target)) return;
    const layout = document.createElement('div'); layout.className = 'co2-guide-layout';
    const aside = document.createElement('aside'); aside.className = 'co2-guide-aside';
    const details = document.createElement('details'); details.className = 'co2-guide-contents';
    const summary = document.createElement('summary'); summary.textContent = 'In this guide';
    const nav = document.createElement('nav'); nav.setAttribute('aria-label','In this guide');
    links.forEach(({target,label},index) => {
      if (!target.id) {
        const base = 'guide-' + label.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/-$/,'');
        let id=base, suffix=2; while(document.getElementById(id)) id=base+'-'+suffix++;
        target.id=id;
      }
      target.classList.add('co2-guide-anchor');
      const a=document.createElement('a'); a.href='#'+target.id; a.textContent=label; nav.append(a);
    });
    details.append(summary,nav); aside.append(details);
    const content=document.createElement('div'); content.className='co2-guide-content';
    blocks[0].before(layout); layout.append(aside,content); blocks.forEach(el=>content.append(el));
    const desktop=window.matchMedia('(min-width:1100px)');
    const resize=()=>{details.open=desktop.matches;}; resize(); desktop.addEventListener('change',resize);
    summary.addEventListener('click',event=>{if(desktop.matches)event.preventDefault();});
    nav.addEventListener('click',event=>{
      const a=event.target.closest('a'); if(!a)return;
      const target=document.getElementById(new URL(a.href).hash.slice(1)); if(!target)return;
      event.preventDefault(); if(!desktop.matches)details.open=false;
      history.pushState(null,'','#'+target.id); target.scrollIntoView({block:'start'});
      target.setAttribute('tabindex','-1'); target.focus({preventScroll:true});
    });
    let pending=false;
    const update=()=>{
      pending=false; let active=0;
      links.forEach((item,index)=>{if(item.target.getBoundingClientRect().top<=150)active=index;});
      [...nav.children].forEach((a,index)=>{if(index===active)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current');});
    };
    const scroll=()=>{if(!pending){pending=true;requestAnimationFrame(update);}};
    window.addEventListener('scroll',scroll,{passive:true}); update();
    const hashTarget=links.find(item=>'#'+item.target.id===location.hash);
    if(hashTarget)requestAnimationFrame(()=>hashTarget.target.scrollIntoView({block:'start'}));
    const unload=event=>{
      if(!event.target.contains(root))return;
      window.removeEventListener('scroll',scroll);desktop.removeEventListener('change',resize);document.removeEventListener('shopify:section:unload',unload);
    };
    document.addEventListener('shopify:section:unload',unload);
  }
  mount(); document.addEventListener('shopify:section:load',mount);
})();
